import { type PrecomputedEvaluationsInterface, StatsigClient } from '@statsig/react-bindings';
import { type z } from 'zod';
import { attempt } from '@/helpers/functional';
import { type rootSearchSchema } from '@/router/utils';
import { Cookies } from '@/utils/cookies';
import { isProductionEnv, isStagingEnv } from '@/utils/utils';

const getStatsigTier = (): 'production' | 'staging' | 'development' => {
  if (isProductionEnv) {
    return 'production';
  }
  if (isStagingEnv) {
    return 'staging';
  }

  return 'development';
};

export const createStatsigClient = (search: z.infer<typeof rootSearchSchema>) =>
  new StatsigClient(
    window.__QDRANT_CLOUD__.statsig.client_key,
    {
      userID: undefined,
      email: undefined,
      appVersion: window.__QDRANT_CLOUD__.version,
      userAgent: window.navigator.userAgent,
      custom: {
        ...Object.fromEntries(
          Object.entries(search)
            .filter(([param]) => param.startsWith('utm_'))
            .map(([key, value]) => [`utm_params.${key}`, value]),
        ),
        ...Object.fromEntries(
          Object.entries(Cookies.get())
            .filter(([cookieName]) => cookieName.startsWith('statsig_'))
            .map(([key, value]) => [`cookies.${key}`, value]),
        ),
        userCreatedAt: undefined,
        account_id: undefined,
      },
    },
    {
      environment: {
        tier: getStatsigTier(),
      },
      networkConfig: {
        initializeUrl: new URL('/v1/feature-config', window.location.origin).toString(),
      },
    },
  );

export const isStatsigClientReady = (client: PrecomputedEvaluationsInterface | undefined): client is StatsigClient => {
  if (!client) {
    return false;
  }
  return attempt(
    () => Boolean(client.getContext()),
    () => false,
  );
};
